import { Text, VStack } from "@chakra-ui/react";
import redact from "../../redact";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";

const ReportCard = observer(({ item, index }) => {
  const { pageStore } = useStores();

  const findFio = pageStore.all_managers.find(
    (item2) => item2?.email == item?.user_email
  );
  function formatDate(value){
     const [year, month, day] = value.split("-");
    return `${day}.${month}.${year}`;
  }
  return (
    <VStack
      padding={"10px"}
      borderRadius={"10px"}
      width={"100%"}
      align={"flex-start"}
      bg={index % 2 == 0 ? "#1a1a1a" : "#333"}
      box-shadow={"0 0 10px #00000080"}
    >
      <Text fontSize={"20px"} color={"#007bff"}>
        {formatDate(item?.dateCreated)} - {findFio?.fio} ({findFio?.name_1})
      </Text>
      <Text fontSize={"20px"} color={"myColor.white"}>{redact(item.report)}</Text>
    </VStack>
  );
});

export default ReportCard;
